import React from 'react';

const defaultProps = (props) => (BaseComponent) => {
  const DefaultProps = (ownerProps) => <BaseComponent {...ownerProps} />;
  DefaultProps.defaultProps = props;
  return DefaultProps;
};

export default defaultProps;
